"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGrid = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledFunctions_1 = require("../../helpers/StyledFunctions");
const gridKeys = [
    'gridTemplateColumns',
    'gridTemplateRows',
    'gridTemplateAreas',
    'gridTemplate',
    'gridColumnGap',
    'gridRowGap',
    'gridGap',
    'justifyItems',
    'alignItems',
    'placeItems',
    'justifyContent',
    'alignContent',
    'placeContent',
    'gridAutoColumns',
    'gridAutoRows',
    'gridAutoFlow',
];
const getGrid = (props) => (0, StyledFunctions_1.getCSS)(props, gridKeys);
exports.getGrid = getGrid;
const Grid = (0, styled_components_1.default)('div') `
  display: ${props => (props.inline ? 'inline-grid' : 'grid')};
  ${props => props.block && 'width: 100%;'}
  ${exports.getGrid}
  ${StyledFunctions_1.getMargin}
  ${StyledFunctions_1.getPadding}
`;
exports.default = Grid;
